import Ajax from '../libraries/Ajax'

export const byLocation = (lat, lng, limit) =>
    Ajax.get(`users/list_users/0/${limit}`, {lat, lng})
    
export const toggleFollow = (id_user) =>
    Ajax.get(`users/toggle_follow/${id_user}`)

export const filter = (filter, limit = 20) =>
    Ajax.get(`users/list_users/0/${limit}?filter=${filter}`)


// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/utils/users.js